"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import classes from './styles.module.css.mjs';
import { Tag } from './Tag.mjs';

const TagPlaceholder = forwardRef(function({ children, className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    Tag,
    {
      ref,
      className: clsx(classes.tagPlaceholder, !!props?.onClick && classes.tagPlaceholder__clickable, className),
      ...props,
      children
    }
  );
});

export { TagPlaceholder };
